import React, { Component } from 'react';
import { HexAlphaColorPicker, HexColorInput } from 'react-colorful';
import toggleColorPicker from '../../../Functions/toggleColorPicker';

class ContainerSettings extends Component {
    constructor(props) {
        super(props);
    }

    renderIncrementalSetting = (label, value, name, step = 1, min = 0) => {
        let displayValue = value;
        let unit = 'px';

        if (name === 'container.containerMaxWidth') {
            unit = '%';
        }

        if (typeof value === 'string') {
            const match = value.match(/^([\d.]+)(.*)$/);
            if (match) {
                displayValue = match[1];
            }
        }

        return (
            <div className='mjwi-row'>
                <div className='mjwi-col50'>
                    <label>{label}</label>
                </div>
                <div className='mjwi-col50'>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <input
                            type="number"
                            name={name}
                            value={displayValue || ''}
                            onChange={(e) => {
                                let val = e.target.value;
                                if (name === 'container.containerMaxWidth') {
                                    val = Math.min(100, Math.max(min, parseFloat(val) || min));
                                }
                                this.props.handleInputChange({ 
                                    target: { 
                                        name, 
                                        value: val ? `${parseFloat(val) || min}${unit}` : `${min}${unit}` 
                                    } 
                                }, ['container']);
                            }}
                            className="mjwi-input"
                            min={min}
                            max={name === 'container.containerMaxWidth' ? 100 : undefined}
                            style={{ flexGrow: 1 }}
                        /> {unit}
                    </div>
                </div>
            </div>
        );
    };


    renderStylingSettings = () => {
        const { tripadvisor } = this.props;
        const fontFamilyOptions = [
            { value: 'Arial, sans-serif', label: 'Arial' },
            { value: 'Helvetica, sans-serif', label: 'Helvetica' },
            { value: 'Times New Roman, serif', label: 'Times New Roman' },
            { value: 'Georgia, serif', label: 'Georgia' },
            { value: 'Verdana, sans-serif', label: 'Verdana' },
            { value: 'Roboto, sans-serif', label: 'Roboto' }
        ];

        return (
            <div className='mjwi-acc-panel-wrapper'>
                {this.renderIncrementalSetting('Width', tripadvisor.container.containerMaxWidth, 'container.containerMaxWidth', 5, 10)}
            </div>
        );
    };

    render() {
        return this.props.renderSection('Container', this.renderStylingSettings(), 'container-settings');
    }
}

export default ContainerSettings;